<template>
  <div class="ion-page">
    <ion-header-bar class="bar-positive">
      <h1 class="title">
        <span>
          <img class="title-image" src="../../assets/logo.png" height="80%" />
          Fairfield Allergy Reset Password</span
        >
      </h1>
    </ion-header-bar>

    <ion-content class="ion-padding">
      <ion-spinner
        class="spinner"
        v-if="showSpinner"
        name="bubbles"
      ></ion-spinner>
      <ion-grid>
        <ion-row justify-content-center>
          <ion-col align-self-center size-md="6" size-lg="5" size-xs="12">
            <div padding>
              <ion-item>
                <ion-input
                  type="password"
                  :value="newPassword"
                  ref="theNewPassword"
                  name="newPassword"
                  placeholder="New Password"
                ></ion-input>
              </ion-item>
            </div>
            <div padding>
              <ion-item>
                <ion-input
                  type="password"
                  :value="confirmPassword"
                  ref="theConfirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                ></ion-input>
              </ion-item>
            </div>
            <div padding>
              <ion-button
                size="default"
                id="patientLogin"
                class="adjust-font-size"
                @click="resetPassword"
                expand="block"
                >Submit</ion-button
              >
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </div>
</template>
<script>
import Repository from "../../repositories/RepositoryFactory";
var AuthorizationRepository = Repository.get("authorization");
export default {
  name: "adminlogin",
  data() {
    return {
      info: null,
      userEmail: "",
      newPassword: "",
      confirmPassword: "",
      showSpinner: false,
    };
  },
  methods: {
    resetPassword: async function () {
      this.newPassword = this.$refs.theNewPassword.value;
      this.confirmPassword = this.$refs.theConfirmPassword.value;

      if (this.newPassword === this.confirmPassword) {
        var resetThePassword = {
          UserName: this.$store.state.email,
          Password: this.newPassword,
          ConfirmPassword: this.confirmPassword,
          OldPassword: "None",
          Token: this.$store.state.token,
        };

        this.showSpinner = true;

        var result = await AuthorizationRepository.resetPassword(
          resetThePassword
        );
        // eslint-disable-next-line no-console
        console.log(result);
        this.$store.state.token = result.data.token;
        this.showSpinner = false;

        let self = this;
        self.$router.push({
          name: "main",
        });
      } else {
        alert("Passwords do not match");
      }

      //  self.$router.push({ name: "resetpassword" });
    },
  },
};
</script>
